import type { ReactNode } from 'react';

import Text from 'components/core/typography/Text';
import { Clickable } from 'components/ui/shared/Buttons/Clickable';
import { BannerStyle } from 'enums/bannerStyle';

import { BannerContainer, BannerLink, FlexRow, TextContainer } from './Banner.styles';

interface Props {
  /**
   * Accessible label for the icon-only CTA button (e.g. "Close") — without it the CTA has no accessible name
   */
  ctaAriaLabel?: string;
  ctaLabel?: ReactNode;
  ctaTestId?: string;
  icon?: ReactNode;
  onClick?: () => void;
  styleVariant?: BannerStyle;
  testId?: string;
  title: ReactNode;
}

const Banner = ({
  ctaAriaLabel,
  ctaLabel,
  ctaTestId,
  icon,
  onClick,
  styleVariant = BannerStyle.NEUTRAL,
  testId,
  title,
}: Props) => (
  <BannerContainer $styleVariant={styleVariant} data-testid={testId}>
    <FlexRow>
      {icon}
      <TextContainer>
        <Text>{title}</Text>
        {!!onClick && !!ctaLabel && (
          <Clickable aria-label={ctaAriaLabel} data-testid={ctaTestId} onClick={onClick}>
            <BannerLink>{ctaLabel}</BannerLink>
          </Clickable>
        )}
      </TextContainer>
    </FlexRow>
  </BannerContainer>
);

export default Banner;
